import complete from './complete.png';
import warning from './warning.png';
import Equipment from './Equipment.png';
import Security from './Security.png';
import rightArrow from './rightarrow.png';
import rightArrowGary from './rightarrow-gary.png';
import logo from './logo.svg';
import wechatGrey from './wechatGrey.svg';
import wechatActive from './wechatActive.svg';
import weibotGrey from './weibotGrey.svg';
import weiboActive from './weiboActive.svg';
import huawei from './huawei.svg';
import browser from './browser.svg';
import Phone from '../Phone.svg';
import authority from './icon/authority.svg';
import user from './icon/user.svg';
import application from './icon/application.svg';
import authorityActive from './icon/authority-active.svg';
import userActive from './icon/user-active.svg';
import applicationActive from './icon/application-active.svg';

export default {
  complete,
  warning,
  Equipment,
  Security,
  rightArrow,
  rightArrowGary,
  logo,
  wechatGrey,
  wechatActive,
  weibotGrey,
  weiboActive,
  huawei,
  browser,
  Phone,
  authority,
  user,
  application,
  authorityActive,
  userActive,
  applicationActive
};
